import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import RacesPage from './components/RacesPage';
import RaceRequestsPage from './components/RaceRequestsPage';
import AmbassadorsPage from './components/AmbassadorsPage';
import AmbassadorApplicationsPage from './components/AmbassadorApplicationsPage';
import './App.css';

// Lazy load SharePage since it has heavy dependencies (FFmpeg, Firebase, etc.)
const SharePage = lazy(() => import('./components/SharePage'));
const GiftSuccessPage = lazy(() => import('./components/GiftSuccessPage'));

// Simple loading component
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#ffffff',
    color: '#6b7280'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '3px solid #e5e7eb',
      borderTop: '3px solid #3b82f6',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: '1rem'
    }}></div>
    <p>Loading...</p>
    <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `
    }} />
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/r/:token" element={<SharePage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/races" element={<RacesPage />} />
            <Route path="/raceRequests" element={<RaceRequestsPage />} />
            <Route path="/ambassadors" element={<AmbassadorsPage />} />
            <Route path="/ambassadorApplications" element={<AmbassadorApplicationsPage />} />
            <Route path="/gift-success" element={<GiftSuccessPage />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;